import { datadogRum } from '@datadog/browser-rum';
import { QUERIES_KEYS, QUERY_STALE_TIME } from 'constant';
import queryClient from 'remote-state/queryClient';
import { getUser } from 'services/userService';

export enum UserPermission {
  SYSAID_ADMIN = 'isSysAidAdmin',
}

export const userPermissionGuard = async (permission: UserPermission, defaultValue = false): Promise<boolean> => {
  try {
    const userData = await queryClient.ensureQueryData({
      queryKey: [QUERIES_KEYS.CURRENT_USER],
      queryFn: () => getUser(),
      staleTime: QUERY_STALE_TIME.MEDIUM,
    });

    switch (permission) {
      case UserPermission.SYSAID_ADMIN:
        return Boolean(userData?.coreUser?.isSysAidAdmin);
      default:
        return defaultValue;
    }
  } catch (error) {
    const errorInstance = error instanceof Error ? error : new Error(String(error));
    datadogRum.addError(errorInstance, {
      info: 'Unexpected error caught during user permissions check',
    });

    return defaultValue;
  }
};
